import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNotePlanBody, PatientCareCenterNotePlanEvalBody, PatientCareCenterNotePlanBodyDC } from 'PatientCareCenter/Note/WorkProgram/Plan'
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'
import { PatientCareCenterNotePlanCI } from 'PatientCareCenter/Note/Plan';
class PatientCareCenterNoteWpPlan extends React.Component {

    render() {
        const dropdownOptions = [
            { id: '1-2', value: '1-2' },
            { id: '2-3', value: '2-3' },
            { id: '3-4', value: '3-4' },
            { id: '4-5', value: '4-5' },
            { id: '5-6', value: '5-6' },
            { id: '6-7', value: '6-7' },
            { id: '7-8', value: '7-8' },
            { id: '8+', value: '8+' },
            { id: 'N/A', value: 'N/A' }
        ];

        return (
            <PatientCareCenterNoteSection id='plan' name='Plan' refProp={this.props.refProp} className={styles.required}>
                {(this.props.noteType === 1) &&
                    <PatientCareCenterNotePlanEvalBody customOption={dropdownOptions} />
                }
                {(this.props.noteType === 2 || this.props.noteType === 3 || this.props.noteType === 5) &&
                    <PatientCareCenterNotePlanBody customOption={dropdownOptions} />
                }

                {(this.props.noteType === 4 || this.props.noteType === 6) &&
                    <PatientCareCenterNotePlanBodyDC />
                }
                <PatientCareCenterNotePlanCI />
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    return {
        noteType
    };
}

const connectedPatientCareCenterNoteWpPlan = connect(mapStateToProps)(PatientCareCenterNoteWpPlan);
export { connectedPatientCareCenterNoteWpPlan as PatientCareCenterNoteWpPlan };




